module.exports = __webpack_public_path__ + "static/media/icon_calendar.87532ed8.svg";